
import InViewPort from "../../Components/InViewPort";
import About from "./Components/About";
import ClientsKera from "./Components/ClientsKera";
import CounterKera from "./Components/CounterKera";
import Introduction from "./Components/Introduction";
import UnknownSection from "./Components/UnknownSection";


// Filter the blog data category wise

const Home = (props) => {
  return (
    <div className="financepage" style={props.style}>
      <Introduction />
      <InViewPort>
        <About />
        <CounterKera />
        <UnknownSection />
        <ClientsKera />
      </InViewPort>
    </div >
  );
};

export default Home;